const OBJECT_ID_PATTERN = /^[a-f0-9]{24}$/i

export function isValidConversationId(value: string): boolean {
  return OBJECT_ID_PATTERN.test(value.trim())
}

/**
 * Accepts either a bare Mongo ObjectId or a pasted conversation URL
 * (e.g. `${REACT_APP_USER_PANEL_URL}/conversations?...&convId=<id>`)
 * and returns the ObjectId if one can be found.
 */
export function extractConversationId(raw: string): string | undefined {
  const trimmed = raw.trim()
  if (!trimmed) return undefined

  if (isValidConversationId(trimmed)) return trimmed

  try {
    const url = new URL(trimmed)
    const fromQuery =
      url.searchParams.get("convId") || url.searchParams.get("conversationId")
    if (fromQuery && isValidConversationId(fromQuery)) return fromQuery
  } catch {
    // not a URL, ignore
  }

  return undefined
}
